<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          エラーはありませんでした。
        </p>
        <p v-else>
          指定しているページにJavaScriptのエラーが発生しています。
        </p>
      </div>
    </li>
    <li
      v-if="detail.errorCount || detail.errorCount === 0"
      class="c-list--checkup__item"
    >
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <p>エラー数: {{ detail.errorCount }}</p>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          JavaScriptのエラーを解決してください。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  }
};
</script>
